import React from "react";
import Draggable from "react-draggable";

import { DraggableLogoContainer } from "../Logo/styles";
import { DraggableVerticalRectangleContainer } from "./styles";

import { DraggableLabels } from "../Labels";

import { getColor } from "../shapes-utils";

export default function DraggableVerticalRectangle({
  positions,
  setPositions,
  size = 180,
  verticalRectangleSizes,
  selectedImage,
  variantColor,
  texts,
  logoSrc,
  x_axis = 50,
}) {
  const handleDrag = (index, e, data) => {
    const newPositions = [...positions];
    newPositions[index] = { x: data.x, y: data.y };
    setPositions(newPositions);
  };
  return (
    <DraggableVerticalRectangleContainer
      className="shape-container"
      size={size}
      background={getColor(variantColor).primary}
    >
      <Draggable
        key={0}
        bounds={{
          // left: -verticalRectangleSizes.imageSize.width / 2,
          top: -verticalRectangleSizes.imageSize.height / 2,
          // right: size - verticalRectangleSizes.imageSize.width / 2,
          bottom: size / (9 / 16) - verticalRectangleSizes.imageSize.height / 2,
        }}
        position={positions[0]}
        onDrag={(e, data) => handleDrag(0, e, data)}
      >
        <div
          style={{
            width: verticalRectangleSizes.imageSize.width + "px",
            height: verticalRectangleSizes.imageSize.height + "px",
            cursor: "move",
            position: "absolute",
          }}
        >
          <img
            src={selectedImage}
            alt="drag verticalRectangle imag"
            style={{
              width: "100%",
              height: "100%",
              pointerEvents: "none",
              userSelect: "none",
              objectFit: "cover",
              objectPosition: `${x_axis}% 50%`,
            }}
          />
        </div>
      </Draggable>

      <Draggable
        key={1}
        bounds="parent"
        position={positions[1]}
        onDrag={(e, data) => handleDrag(1, e, data)}
      >
        <DraggableLogoContainer size={verticalRectangleSizes.logoSize}>
          <img
            src={logoSrc}
            alt="drag verticalRectangle imag"
            style={{
              // width: "100%",
              // height: "100%",
              pointerEvents: "none",
              userSelect: "none",
              objectFit: "cover",
            }}
          />
        </DraggableLogoContainer>
      </Draggable>

      <Draggable
        key={11}
        bounds="parent"
        position={positions[2]}
        onDrag={(e, data) => handleDrag(2, e, data)}
      >
        <div
          style={{
            width: verticalRectangleSizes.labelsSize.width + "px",
            cursor: "move",
            position: "absolute",
          }}
        >
          <DraggableLabels
            style={{
              pointerEvents: "none",
            }}
            callBackground={getColor(variantColor).secondary}
            callText={texts.callText}
            callTextColor={getColor(variantColor).callTextColor}
            primaryText={texts.primaryText}
            secondaryText={texts.secondaryText}
            size={verticalRectangleSizes.labelsSize}
            textColor={getColor(variantColor).textColor}
          />
        </div>
      </Draggable>
    </DraggableVerticalRectangleContainer>
  );
}
